import GlobalContext from 'contexts';
import useFetchData from 'hooks/useFetchData';
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PersonalDetailsContent from 'components/PersonalDetails/components/content';
import rightArrowIcon from '../../../../assets/images/rightarrow.png';
import { fieldsMeetingDetails, fieldsMeetingMeasures } from './utils';
import './styles.scss';
import { findIndex } from 'lodash';
import Graphs from 'components/Graphs';
import { calcBMI, getAge } from 'utils';

const Measures = () => {
  const {
    currentCustomer,
    setLink,
    setOpenDrawer,
    openDrawer,
    setCurrentMeeting,
    currentMeeting,
    measuresData,
    setMeasuresData
  } = useContext(GlobalContext);
  const { id: clientUuid } = useParams();
  const { data } = useFetchData('measure', clientUuid);
  const [listMeasuresData, setListMeasuresData] = useState();

  useEffect(() => {
    const element = document.querySelector(`.measures-page`);
    element?.scrollIntoView();
  }, []);

  useEffect(() => {
    if (data) {
      let tmp = [...data];
      for (let index = 0; index < tmp.length; index++) {
        tmp[
          index
        ].bloodPressure = `${tmp[index].bloodPressureSys}/${tmp[index].bloodPressureDys}`;
      }
      setListMeasuresData(tmp);
      setMeasuresData(tmp);
    }
  }, [data]);

  useEffect(() => {
    let index = findIndex(measuresData, { changed: true });
    if (index > -1) {
      setListMeasuresData(measuresData);
      let deepMeasures = [...measuresData];
      delete deepMeasures[index].changed;
      setMeasuresData(deepMeasures);
    }
  }, [measuresData]);

  const fieldsStartData = [
    { label: 'גיל', name: 'age' },
    { label: 'מגדר', name: 'gender' },
    { label: '  גובה(בס"מ)', name: 'height' },
    { label: 'משקל התחלתי', name: 'weight' },
    { label: 'BMI', name: 'bmi' }
  ];

  const startData = {
    age: getAge(currentCustomer.date_of_birth),
    gender: currentCustomer.gender,
    height: currentCustomer.height,
    weight: currentCustomer.weight,
    bmi: calcBMI(currentCustomer.height, currentCustomer.weight)
  };

  return (
    <div className="measures-page">
      <div className="title-navigation">
        <img src={rightArrowIcon} onClick={() => setLink(null)}></img>
        <div className="wrapper-title">
          <div className="user-name">
            {currentCustomer?.first_name} {currentCustomer?.last_name}
          </div>
          <div className="page-title">מדדים</div>
        </div>
      </div>
      <div className="wrapper-measures">
        <div className="measures-area">
          <div className="box-details">
            <div className="box-details-title">{'נתוני התחלה'}</div>
            <PersonalDetailsContent
              fields={fieldsStartData}
              data={startData}
            ></PersonalDetailsContent>
          </div>
          <div className="measures-list">
            <div className="measures-list-title">מדדים שנמדדו בפגישות</div>
            {listMeasuresData?.map((measuresMeeting, key) => (
              <div
                key={key}
                className={`box-details ${
                  currentMeeting?.id == measuresMeeting.id && 'selected'
                }`}
                onClick={() => {
                  if (!openDrawer) {
                    setCurrentMeeting(measuresMeeting);
                    setOpenDrawer('editMesaure');
                  } else {
                    setCurrentMeeting(null);
                    setOpenDrawer(null);
                  }
                }}
              >
                <PersonalDetailsContent
                  fields={fieldsMeetingDetails}
                  data={measuresMeeting}
                ></PersonalDetailsContent>
                <PersonalDetailsContent
                  fields={fieldsMeetingMeasures}
                  data={measuresMeeting}
                ></PersonalDetailsContent>
              </div>
            ))}
          </div>
        </div>

        <div className="graphs-area">
          <Graphs measure={'weight'} measuresData={listMeasuresData} />
          <Graphs measure={'fatPct'} measuresData={listMeasuresData} />
          <Graphs
            measure={'bloodPressureDys'}
            measuresData={listMeasuresData}
          />
          <Graphs measure={'MuscleMass'} measuresData={listMeasuresData} />
          <Graphs measure={'muscleStrength'} measuresData={listMeasuresData} />
          <Graphs
            measure={'flexibilityIndex'}
            measuresData={listMeasuresData}
          />
        </div>
      </div>
    </div>
  );
};

export default Measures;

// CreateCustomer.propTypes = {
//     handleAddCustomerToOrg: PropTypes.func
// };
